import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

// common
import Modal, { ModalText, ModalButton } from "common/modal";
import ErrorAlerting from "common/error_alerting";
import { AlertProps } from "types";

const { ConfirmationText } = ModalText;

type TProps = {
  visible: boolean;
  onCloseModal: () => void;
  onConfirm: () => void;
  loading: boolean;
  onClick: () => void;
  subscribeAgain: boolean | undefined;
  renewalDate: string | undefined;
  chosenProgram?: any;
  errors: AlertProps[] | undefined;
  closeError: (index: number) => void;
};

const SubscribeConfirmationModal = ({
  visible,
  onCloseModal,
  onConfirm,
  onClick,
  loading,
  subscribeAgain,
  renewalDate,
  chosenProgram,
  errors,
  closeError,
}: TProps) => {
  const { t } = useTranslation("my_credits");
  const formattedDate = renewalDate
    ? moment(new Date(renewalDate)).format("MMM DD, YYYY")
    : "";

  let modalMessage;
  let modalTitle;
  // configure modal object
  if (chosenProgram?.type === "package") {
    modalTitle = "PAY NOW";
    modalMessage = t(
      "Pay now to receive your Flexi Credits immediately. This is a one-off payment. This can take a little while. Please do not close or refresh this page while your request is being processed."
    );
  } else if (!renewalDate) {
    modalTitle = "SUBSCRIBE NOW";
    modalMessage = t(
      "Subscribe to receive and pay for your Flexi Credits immediately. \n\nNote: You can cancel your subscription at any time. All credits will remain valid and you can continue to use Flexi Classes without restrictions after canceling."
    );
  } else if (subscribeAgain) {
    modalTitle = "SUBSCRIBE AGAIN";
    modalMessage = t(
      "Your previous subscription has been canceled, but will only expire on {{formattedDate}}. If you sign up for a new subscription now, you will not be charged. The new subscription will be charged and credits given only on {{formattedDate}}.",
      { formattedDate }
    );
  } else {
    modalTitle = "CHANGE SUBSCRIPTION";
    modalMessage = t(
      "You still have an active subscription until {{formattedDate}}. If you change your subscription now, you will not be charged. The new subscription will be charged and credits given only on {{formattedDate}}.",
      { formattedDate }
    );
  }
  return (
    <Modal
      title={t(modalTitle)}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
      modalWidth="100%"
      maskClosable={!loading}
    >
      {errors && (
        <div>
          <br />
          <ErrorAlerting errors={errors} onClose={closeError} />
        </div>
      )}
      <ConfirmationText style={{ marginTop: "0", fontSize: "17px" }}>
        {modalMessage}
      </ConfirmationText>
      <div style={{ display: "flex" }}>
        <ModalButton
          onClick={() => {
            // instead of waiting for the user to hit click on the change/subscribe button, fire the function right after he uses the okay button
            onConfirm();
            if (visible) onClick();
          }}
          loading={loading}
        >
          {t("YES")}
        </ModalButton>
        <ModalButton onClick={() => onCloseModal()}>{t("NO")}</ModalButton>
      </div>
    </Modal>
  );
};

export default SubscribeConfirmationModal;
